import { InputValidationComponent } from 'core/validation/input/input-validation.component'
import { FormValidationComponent } from 'core/validation/form/form-validation.component'
import { constraints } from './constraints'
import { CepService } from './cep.service'
import { CepNavigationMask } from './cep-navigation.mask'
import { CepNavigationObserver } from './cep-navigation.observer'
import { Observable } from 'rxjs'

export class CepNavigationComponent {

    constructor() {
        this.cepNavigationForm = document.querySelector('#cep-navigation-form');
        this.validator = new FormValidationComponent(this.cepNavigationForm, constraints);
        this.service = new CepService();
        this.init();
    }

    init() {
        //change event component
        const inputValidation = new InputValidationComponent(this.cepNavigationForm, constraints).init();

        //masks
        const masks = new CepNavigationMask();

        if(this.cepNavigationForm) {
            let submitStream = Observable.fromEvent(this.cepNavigationForm, 'submit')
            submitStream
                .do(event => event.preventDefault())
                .filter(() => this.validator.validateForm())
                .map(event => this.validator.serializeForm())
                .subscribe(cep => this.changeCep(cep))
        }
        //call request geolocation coords to get a cep
        this.soliciteCepNavigation();
    }

    changeCep(cep) {
        return this.service
                    .changeCep(cep)
                    .subscribe(new CepNavigationObserver(cep));
    }

    getCepNavegacaoGeolocation (lat, lng) {
        return this.service
            .getCepNavegacaoGeolocation(lat, lng)
            .subscribe(data => this.getCepNavegacaoGeolocationCallback(data));
    }

    getCepNavegacaoGeolocationCallback (data) {
        if (data.status != 200) return;
        var zipcodes = [];
        data.data.results.forEach( (result) => {
            result.types.forEach( (type) => {
                if (type == "postal_code") {
                    var address = result.formatted_address;
                    result.address_components.forEach( (component) => {
                        component.types.forEach( (componentType) => {
                            if (componentType == "postal_code") {
                                var cep = component.short_name;
                                if (cep.match(/^\d{5}[-]\d{3}$/) != null && address.indexOf(cep) > 0) zipcodes.push({location: address, zipCode: cep});
                            }
                        })
                    })
                }
            })
        })
        //if (zipcodes.length > 0) this.confirmCepToNavigation(zipcodes);
        if (zipcodes.length > 0) this.setCepNavigation(zipcodes[0]);
    }

    confirmCepToNavigation (zipcodes) {
        if (zipcodes.length == 1) { this.setCepNavigation(zipcodes[0]); return; }
        let i = 0;
        let continueWhile = true;
        while (continueWhile) {
            if (zipcodes.length > i) {
                var elem = zipcodes[i];
                i++;
                var text = "Você está em " + elem.location +" ?";
                    if (window.confirm(text)) {
                        continueWhile = false;
                        this.setCepNavigation(elem);
                    }
            } else {
                continueWhile = false;
            }
        }
    }

    setCepNavigation (elem) {
        if (elem && elem.zipCode) {
            var data = {cepNavegacao: elem.zipCode.replace("-", "")};
            this.changeCep(data);
        }
    }

    soliciteCepNavigation () {
        let timeExpired = this.service.getValueCookieByName("LojaVirtualPanvelCepExpired");
        if (timeExpired == null || timeExpired.length == 0) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition( (position) => {
                    this.getCepNavegacaoGeolocation(position.coords.latitude, position.coords.longitude);
                })
            }
            this.service.setValueCokieByName("LojaVirtualPanvelCepExpired", "true");
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/cep-navigation/cep-navigation.component.js